const cache = new Map();
const pending = new Map();

export function getCached(key, ttlMs = 60000) {
  const entry = cache.get(key);
  if (!entry) return null;
  if (Date.now() - entry.ts > ttlMs) {
    cache.delete(key);
    return null;
  }
  return entry.data;
}

export function setCached(key, data) {
  cache.set(key, { data, ts: Date.now() });
}

export function getOrFetchCached(key, ttlMs, fetcher) {
  const cached = getCached(key, ttlMs);
  if (cached !== null) return Promise.resolve(cached);

  const existingRequest = pending.get(key);
  if (existingRequest) return existingRequest;

  const request = Promise.resolve()
    .then(fetcher)
    .then(data => {
      setCached(key, data);
      return data;
    })
    .finally(() => pending.delete(key));

  pending.set(key, request);
  return request;
}

export function invalidateCache(pattern) {
  if (!pattern) {
    cache.clear();
    pending.clear();
    return;
  }
  for (const key of cache.keys()) {
    if (key.includes(pattern)) cache.delete(key);
  }
  for (const key of pending.keys()) {
    if (key.includes(pattern)) pending.delete(key);
  }
}